<!--
  @author:chen.hao
  @time:2018/11/6
  @disc:供应商管理查看弹出层
 -->

<template>
  <el-dialog
    title="查看"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show',false)">
    <info :info-data="info"></info>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Info from './info'
export default {
  name: 'infoViewDialog',
  components: { Info },
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {}
    }
  },
  watch: {
    show () {
      this.visible = this.show
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
